import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    mountedLabel: string;
    mountingLabel: string;
    ejectingLabel: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Describes a project mounted by the Frame.io Drive app */
            mountedLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MountStatusBadge.mountedLabel?c=2ebdd663txwyb", defaultMessage: "Project is Mounted" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Describes a project the Frame.io Drive app is mounting */
            mountingLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MountStatusBadge.mountingLabel?c=3cq541ux4ubwd", defaultMessage: "Project is Mounting" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Describes a project the Frame.io Drive app is ejecting */
            ejectingLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MountStatusBadge.ejectingLabel?c=1k4zl99g43iw5", defaultMessage: "Project is Ejecting" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
